import React from 'react';
import './Dpu_alumni.css';
import Common_title from '../../components/common_components/Common_title/Common_title';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Dpu_alumni = () => {
  const reelsData = [
    {
      id: 3,
      link: 'https://www.instagram.com/reel/DLkwKS4pjYZ/?utm_source=ig_web_copy_link&igsh=MW9xazRndnRya2lrcQ==',
      thumbnail: '/assets/images/home/dpu-alumni/reels/img1.jpg',
    },
    {
      id: 4,
      link: 'https://www.instagram.com/reel/DLEeCF9vsjT/?utm_source=ig_web_copy_link&igsh=MWM4cWsyMzBtMTludw%3D%3D',
      thumbnail: '/assets/images/home/dpu-alumni/reels/img2.jpg',
    },
    {
      id: 5,
      link: 'https://www.instagram.com/reel/DK30Ll_uiNR/?utm_source=ig_web_copy_link&igsh=eHh2dmdnb3I5OGxo',
      thumbnail: '/assets/images/home/dpu-alumni/reels/img3.jpg',
    },
    {
      id: 6,
      link: 'https://www.instagram.com/reel/DKl9UG_B3i1/?utm_source=ig_web_copy_link&igsh=aXR5NzVwejl6Mzdi',
      thumbnail: '/assets/images/home/dpu-alumni/reels/img4.jpg',
    },
  ];

  return (
    <>
      <section className="Dpu_alumni_sec">
        <div className="container">
          <Common_title
            className="text-center"
            title="DPU Reviews "
            subtitle="by candidate who complited online mba program"
          />

          <section className="Our_reels">
            <div className="container">
              <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                spaceBetween={20}
                slidesPerView={2.2}
                breakpoints={{
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                  1024: { slidesPerView: 4 },
                }}
                className="reels_slider"
              >
                {/* {reelsData.map((reel) => (
                  <SwiperSlide key={reel.id}>
                    <a href={reel.link} target="_blank" rel="noreferrer" className="reel_card">
                      <img src={reel.thumbnail} alt="Instagram Reel" />
                      <div className="reel_overlay">
                        
                      </div>
                    </a>
                  </SwiperSlide>
                ))} */}
                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/W1YheUFcOXM"
                    title="Build Your Tech Career with Online MCA"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  >
                    {' '}
                  </iframe>
                </SwiperSlide>

                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/hvZpX4IP8zo"
                    title="Refer and Earn | Profcyma"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  ></iframe>
                </SwiperSlide>

                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/NR_BEG8lais"
                    title="Upgrade Your Career with an Online MBA"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  ></iframe>
                </SwiperSlide>

                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/n_yZU_9G7e0"
                    title="From Doubt to Degree — My Online MBA with Profcyma &amp; Dr. DY Patil University"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  ></iframe>
                </SwiperSlide>
              </Swiper>
            </div>
          </section>
          {/* 
          <div className="row">
            <div className="col-sm-6 mb-3">
              <div>
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/ZqBIfO2JV0A?si=jJPuCYd625_b7Z2k"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div className="col-sm-6 mb-3">
              <div>
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/1-abR2vq5pE?si=JF9sltJh3oER9zqY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Dpu_alumni;
